// extracted by mini-css-extract-plugin
module.exports = {"NoSubmition":"NoSubmition_NoSubmition__XrlfS","NoSubmitionTitle":"NoSubmition_NoSubmitionTitle__SldPs","ApplyBtn":"NoSubmition_ApplyBtn__1RboB"};